export const AUTH_READY_EVENT = 'wklr:auth-ready';
export const AUTH_FAILED_EVENT = 'wklr:auth-failed';
